import { Divider as MUIDivider } from '@mui/material'

import { Divider as DividerProps } from './interface'

export default function Divider({
  orientation = 'horizontal',
  variant = 'fullWidth',
  light = true,
}: DividerProps): JSX.Element {
  return <MUIDivider variant={variant} orientation={orientation} light={light} />
}
